import React from "react";

import './css/work-action.css'

export default function WorkAction(){
    return(
        <div className="work-action">
            <h2>Work Action</h2>
            <div className="work-action-cards"><p>View Intern Data</p></div>
        </div>
    )
}